<div class="details-header">
  <div class="header-row">
    <h1>Artikeldetails</h1>

    <div class="button-row">
      @if (editMode && !newEntity) {
        <button mat-flat-button color="warn" (click)="deleteArticle()">
          Artikel löschen
          <mat-icon>delete_outline</mat-icon>
        </button>
      }

      @if (
        !newEntity && (authService.isAdmin() || authService.isPurchasing())
      ) {
        @if (!editMode) {
          <button matButton="filled" color="primary" (click)="switchEditMode()">
            Artikel bearbeiten
            <mat-icon iconPositionEnd>edit</mat-icon>
          </button>
        } @else {
          <button matButton="filled" (click)="switchEditMode()">
            Bearbeiten abbrechen
            <mat-icon iconPositionEnd>close</mat-icon>
          </button>
        }
      }
    </div>
  </div>

  <a
    (click)="location.back()"
    (keydown.enter)="location.back()"
    tabindex="0"
    class="back-link"
  >
    <mat-icon>arrow_back</mat-icon>
    Zurück
  </a>
</div>

@if (editMode) {
  <form [formGroup]="articleForm" (ngSubmit)="saveArticle()">
    <div class="form-box">
      <section>
        <h3>Allgemein</h3>
        <div class="input-columns-container">
          <div class="input-column">
            <mat-form-field appearance="fill">
              <mat-label>Name</mat-label>
              <input
                matInput
                placeholder="Beispielprodukt"
                formControlName="title"
              />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Beschreibung</mat-label>
              <textarea
                matInput
                placeholder="Dieses Produkt ist für den Einsatz..."
                formControlName="description"
              ></textarea>
            </mat-form-field>
          </div>
          <div class="input-column">
            <mat-form-field appearance="fill">
              <mat-label>Artikelnummer</mat-label>
              <input
                matInput
                placeholder="133337"
                formControlName="internalId"
              />
            </mat-form-field>
            <mat-form-field appearance="fill" formGroupName="productCategory">
              <mat-label>Produktkategorie</mat-label>
              <mat-select formControlName="id">
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="categoryFilterCtrl"
                  ></ngx-mat-select-search>
                </mat-option>
                @for (category of filteredCategories | async; track category) {
                  <mat-option [value]="category.id">
                    {{ category.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-checkbox formControlName="active" color="primary"
              >Aktiv</mat-checkbox
            >
            <mat-checkbox formControlName="soldOut" color="primary"
              >Ausverkauft</mat-checkbox
            >
            <mat-checkbox formControlName="autoOrder" color="primary"
              >Automatische Nachbestellung aktivieren</mat-checkbox
            >
          </div>
        </div>
      </section>
      <section>
        <h3>Bild</h3>
        <div class="input-columns-container">
          <div class="input-column article-image-column">
            <img
              [src]="articleForm.get('photo')?.value"
            />
          </div>
          <div class="input-column">
            <div class="image-upload-container">
              <input type="file" (change)="selectFile($event)" />
              <button
                mat-flat-button
                type="button"
                color="primary"
                [disabled]="!selectedFile"
                (click)="upload()"
              >
                Datei hochladen
                <mat-icon>upload</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section>
        <h3>Artikelgrößen</h3>
        <div class="input-columns-container">
          <div class="input-column">
            <mat-form-field appearance="fill">
              <mat-label>Mengeneinheit</mat-label>
              <input
                matInput
                placeholder="Kilogramm"
                [matAutocomplete]="auto"
                formControlName="unitOfMeasure"
              />
              <mat-autocomplete #auto="matAutocomplete">
                @for (
                  unitOfMeasure of filteredUnits | async;
                  track unitOfMeasure
                ) {
                  <mat-option [value]="unitOfMeasure">
                    {{ unitOfMeasure }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Entnahmeintervall</mat-label>
              <input matInput placeholder="10" formControlName="samplingStep" />
            </mat-form-field>
          </div>
          <div class="input-column">
            <mat-form-field appearance="fill">
              <mat-label>Gewicht (in kg)</mat-label>
              <input
                matInput
                placeholder="10"
                formControlName="weight"
                type="number"
              />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Länge (in cm)</mat-label>
              <input
                matInput
                placeholder="10"
                formControlName="size_length"
                type="number"
              />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Breite (in cm)</mat-label>
              <input
                matInput
                placeholder="10"
                formControlName="size_width"
                type="number"
              />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Höhe (in cm)</mat-label>
              <input
                matInput
                placeholder="10"
                formControlName="size_height"
                type="number"
              />
            </mat-form-field>
          </div>
        </div>
      </section>
      <section>
        <h3>Ablauf</h3>
        <div class="input-columns-container">
          <div class="input-column">
            <mat-form-field appearance="fill">
              <mat-label>Ablaufdatum</mat-label>
              <input
                matInput
                [matDatepicker]="expiryDatePicker"
                formControlName="expiryDate"
                placeholder="TT.MM.JJJJ"
              />
              @if (articleForm.get('expiryDate')?.value) {
                <button
                  matIconButton
                  matIconSuffix
                  type="button"
                  aria-label="Ablaufdatum entfernen"
                  (click)="articleForm.get('expiryDate')?.setValue(null)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
              <mat-datepicker-toggle
                matIconSuffix
                [for]="expiryDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #expiryDatePicker></mat-datepicker>
              <mat-hint
                >Ab diesem Tag wird der Artikel per E-Mail gemeldet</mat-hint
              >
              <mat-error
                >Bitte ein gültiges Datum im Format TT.MM.JJJJ
                angeben.</mat-error
              >
            </mat-form-field>
          </div>
          <div class="input-column">
            <mat-form-field appearance="fill">
              <mat-label>Ablaufnotiz</mat-label>
              <textarea
                matInput
                placeholder="Charge prüfen und ggf. entsorgen"
                formControlName="expiryNote"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </section>
      <div class="form-action-row">
        <button
          mat-flat-button
          color="primary"
          type="submit"
          class="save-btn"
          [disabled]="articleForm.invalid"
        >
          Speichern
          <mat-icon>save</mat-icon>
        </button>
      </div>
    </div>
  </form>
}

@if (!editMode) {
  @if (article | async; as article) {
    <div class="form-box">
      <div class="article-details-container">
        <div class="article-image-column">
          <img [src]="article?.photo ?? defaultImageURL" [alt]="" />
        </div>
        <div class="article-information-column">
          <div class="main-text-container">
            <h2>{{ article.title }}</h2>
            <p>{{ article.description }}</p>
          </div>
          <div class="more-information-container">
            <p>Interne Artikelnummer: {{ article.internalId }}</p>
            <p>Produktkategorie: {{ article?.productCategory?.label }}</p>
            <p>Maßeinheit: {{ article.unitOfMeasure }}</p>
            <p>Entnahmeschritt: {{ article.samplingStep }}</p>
          </div>
          @if (
            article.expiryDate &&
            (authService.isAdmin() || authService.isPurchasing())
          ) {
            <div class="expiry-container">
              <p>Ablaufdatum: {{ article.expiryDate | date: 'dd.MM.yyyy' }}</p>
              @if (article.expiryNote) {
                <p class="expiry-note">Ablaufnotiz: {{ article.expiryNote }}</p>
              }
            </div>
          }
          <div class="sizes-container">
            @if (article?.weight) {
              <p>
                Gewicht:
                {{
                  (article?.weight | number) + 'kg'
                }}
              </p>
            }
            @if (article?.size_length) {
              <p>
                Länge:
                {{
                  (article?.size_length | number) +
                    'cm'
                }}
              </p>
            }
            @if (article?.size_width) {
              <p>
                Breite:
                {{
                  (article?.size_width | number) +
                    'cm'
                }}
              </p>
            }
            @if (article?.size_height) {
              <p>
                Höhe:
                {{
                  (article?.size_height | number) +
                    'cm'
                }}
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  }
}

<h2>Lagerorte</h2>

@if (editMode) {
  <p class="add-element-notice">
    Lagerorte können nur durch eine Warenbuchung hinzugefügt werden.
  </p>
}

@if (!newEntity) {
  <knust-article-storage-locations></knust-article-storage-locations>
}

<h2>Dateien</h2>
@if (newEntity) {
  <p class="add-element-notice">
    Um Dateien hochzuladen, müssen zunächst die Stammdaten abgespeichert werden.
  </p>
} @else if (selectedArticleId(); as articleId) {
  <knust-article-files [articleId]="articleId"></knust-article-files>
}

@if (authService.isAdmin() || authService.isPurchasing()) {
  <h2>Lieferanten-Artikel-Beziehungen</h2>
  @if (newEntity) {
    <p class="add-element-notice">
      Um eine Lieferanten-Artikel-Beziehung hinzuzufügen, müssen zunächst die
      Stammdaten abgespeichert werden.
    </p>
  }
  @if (!newEntity) {
    <knust-vendor-articles></knust-vendor-articles>
  }
}
